import { inject, Injectable } from '@angular/core';

import { type BulkActionId, BulkActionType } from '@core/bulk-actions-legacy';
import { DialogWidth } from '@core/user-interface-legacy';
import { injectSlotsLimitDialogOpenerContract } from '@recruitee/billing-contracts';
import { SubscriptionService } from '@recruitee/company-logic';

@Injectable()
export class ViewsOffersBulkActionsValidatorService {
  private readonly slotsLimitDialogOpener = injectSlotsLimitDialogOpenerContract();
  private readonly subscription = inject(SubscriptionService);

  public isActionPermitted(
    actionId: number | BulkActionId<string>,
    entityIds: Array<number | string>,
  ) {
    switch (actionId) {
      case BulkActionType.RetrieveArchived:
        if (this.subscription.wouldCountExceedLimit(entityIds.length)) {
          this.openSlotsLimitDialog(entityIds.length);
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  private openSlotsLimitDialog(offersCount: number): void {
    this.slotsLimitDialogOpener.open(
      { width: DialogWidth.Small },
      {
        isTrial: this.subscription.isTrial(),
        triggeredFromBulkCount: offersCount,
      },
    );
  }
}
